module.exports = function getResource(label, vars = []) {
    let resources = {
        titleLabel: 'Consultez votre commande',
        orderNumberInputLabel: 'Numéro de commande',
        emailInputLabel: 'Courriel',
        submitButtonLabel: 'Trouver ma commande',
        signInText1: 'Si vous détenez un compte,',
        signInText2: 'pour afficher l’historique des achats.',
        signInLinkText: 'ouvrir une session'
    };
    return resources[label];
};
